const logger = require('../logger/logger')

module.exports = function(address)
{
    this.serverAddress = address;
    this.socketClient = null;

    this.onOpenCallBack = null;
    this.onMessageCallBack = null;
    this.onCloseCallBack = null;
    this.onErrorCallBack = null;

    this.isConnected = false;


    this.connect = ()=>
    {
        try
        {
            this.socketClient = new WebSocket(this.serverAddress);
            this.isConnected = false;
    
            var self = this;
            this.socketClient.onopen = (e) => {self.onOpen(e);};
            this.socketClient.onmessage = (e) => {self.onMessage(e);};
            this.socketClient.onclose = (e) => {self.onClose(e);};
            this.socketClient.onerror = (e) => {self.onError(e);};
        }
        catch(error)
        {
            logger.error(`Following error occurred while connecting to websocket with address ${this.serverAddress}. ${error}`, {}, error)
        }
    }
    
    this.onOpen = (e) =>
    {
        
        try
        {
            this.isConnected = true;

            if (this.onOpenCallBack)
                this.onOpenCallBack();
        }
        catch(error)
        {
            logger.error(`Following error occurred during onOpen event for websocket with address ${this.serverAddress}. ${error}`, {}, error)
        }
        
    }

    this.onMessage = (e) =>
    {
        try
        {
            if (!this.onMessageCallBack)
                return;

            var data = e;
            if (e.data)
            {
                data = JSON.parse(e.data);
            }

            this.onMessageCallBack(data);
        }
        catch(error)
        {
            logger.error(`Following error occurred during onMessage event for websocket with address ${this.serverAddress}. ${error}`, {}, error)
        }
        
    }

    this.onClose = (e) =>
    {
        try
        {
            logger.info("Socked Connection Closed");
            //May be, we should try to reconnect if closing was not done explicitly.
    
            this.isConnected = false;
            if (this.onCloseCallBack)
                this.onCloseCallBack();
        }
        catch(error)
        {
            logger.error(`Following error occurred during onClose event for websocket with address ${this.serverAddress}. ${error}`, {}, error)
        }
    }

    this.onError = (e) =>
    {
        try
        {
            var errorMessage = "Following error received from socket connection to '" + this.serverAddress + "'. " + e.toString();
            logger.info(errorMessage)
    
            if (this.onErrorCallBack)
                this.onErrorCallBack(errorMessage);
        }
        catch(error)
        {
            logger.error(`Following error occurred during onError event for websocket with address ${this.serverAddress}. ${error}`, {}, error)
        }
        
    }

    this.sendMessage = (message) =>
    {
        try
        {
            this.socketClient.send(message);
        }
        catch(error)
        {
            logger.error(`Following error occurred while sending a websocket message. ${error}`, {}, error)
        }
    }


    this.close = () =>
    {
        logger.info("Closing Socket Connection ");
        try
        {
            this.isConnected = false;
            this.socketClient.close();
        }
        catch(error)
        {
            logger.error("Following error occurred while closing web socket connection to '" + this.serverAddress + "'. " + error, {}, error)
        }
    }

    this.isSocketConnected = ()=>
    {
        return this.isConnected == true;
    }
}